import NovaMoneyInput from './NovaMoneyInput';

export { NovaMoneyInput };
export default NovaMoneyInput;
